<script>
import { gsap } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'
// import VideoBackground from '@/components/_common/VideoBackground.vue'
gsap.registerPlugin(CSSPlugin)
export default {
  name: 'TheHero',
  components: {
    // VideoBackground
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    videoSource () {
      let vid
      const vidType = this.checkHEVCSupport() ? 'mov' : 'webm'
      switch (this.$mq) {
        case 'mobile':
          vid = `/video/MAIN_22_480.${vidType}`
          break
        case 'tablet':
          vid = `/video/MAIN_22_960.${vidType}`
          break
        case 'desktop':
          vid = `/video/MAIN_22_960.${vidType}`
          break
        case 'widescreen':
          vid = `/video/MAIN_22_960.${vidType}`
          break
        case 'fullhd':
          vid = `/video/MAIN_22_960.${vidType}`
          break
      }
      return vid
    },
    posterImage () {
      let poster
      switch (this.$mq) {
        case 'mobile':
          poster = require('@/assets/promo/img/home/hero/eye_bg_fade@0.25x.webp')
          break
        case 'tablet':
          poster = require('@/assets/promo/img/home/hero/eye_bg_fade@0.25x.webp')
          break
        case 'desktop':
          poster = require('@/assets/promo/img/home/hero/eye_bg_fade@0.25x.webp')
          break
        case 'widescreen':
          poster = require('@/assets/promo/img/home/hero/eye_bg_fade@0.25x.webp')
          break
        case 'fullhd':
          poster = require('@/assets/promo/img/home/hero/eye_bg_fade@0.25x.webp')
          break
      }
      return poster
    }
  },
  methods: {
    checkHEVCSupport() {
      const video = document.createElement('video')

      // Checking for 'hev1' and 'hvc1' codec profiles
      const canPlayHev1 = video.canPlayType('video/mp4; codecs="hev1"')
      const canPlayHvc1 = video.canPlayType('video/mp4; codecs="hvc1"')
      if (canPlayHev1 === "probably" || canPlayHvc1 === "probably") {
        return true // HEVC is supported
      }
      return false;
}
  },
  created () {
    console.log(this.checkHEVCSupport())
  },
  mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<template>
  <section class="the-hero">
    <template v-if="$mq === 'mobile'">
      <section class="mobile-hero">
        <header class="hero-text-content">
          <h1 class="mobile-title text-outline-dark has-text-watermelon">
            <span class="mr-1">OUR</span>
            <span class="mr-1">VISUAL</span>
            <span class="">BRAIN</span>
          </h1>
        </header>
        <div class="mobile-grid mt-2">
          <div>
            <h2 class="mobile-grid-text">
              A clinician-guided vision therapy platform that connects care across the full therapy arc.
            </h2>
          </div>
          <aside>
            <div class="vid-overlay">
              <video
                  title="video collage"
                  aria-hidden="true"
                  class="video-player"
                  :src="videoSource"
                  object-fit="contain"
                  loop
                  muted
                  playsinline
                  :autoplay="true"
                  disablePictureInPicture
                  :controls="false"
              />
              <div class="overlay" />
            </div>
          </aside>
        </div>
      </section>
    </template>
    <template v-else>
      <section class="hero-grid">
        <article class="hero-text-content">
          <h1 class="h1-promo mb-4-tablet mb-2 text-outline-dark has-text-watermelon">OUR VISUAL BRAIN</h1>
          <h2 class="h2-promo">
            A clinician-guided vision therapy platform that connects care across the full therapy arc.
          </h2>
        </article>
        <aside>
          <div class="vid-overlay">
            <video
                class="video-player"
                :src="videoSource"
                object-fit="contain"
                loop
                muted
                playsinline
                :autoplay="true"
                disablePictureInPicture
                :controls="false"
                title="video collage"
                aria-hidden="true"
            />
            <div class="overlay" />
          </div>
        </aside>
      </section>
    </template>
  </section>
</template>

<style lang="scss" scoped>

.the-hero {
  margin: 1rem 0 1.5rem 0;
  @include tablet {
    margin: 4.5rem 0 0 0;
  }
  @include desktop {
    margin: 2.5rem 0 20rem 0;
  }
  flex-grow: 1;
  color: $white;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  .mobile-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
    &-text {
      font-weight: $font-semibold;
      font-size: $size-5;
      line-height: 1.24;
    }
  }
  .mobile-title {
    font-size: 2.45rem;
    font-weight: 900;
    line-height: 1;
    letter-spacing: -0.15rem;
  }
  .hero-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr;
    }
  }
  .hero-text-content {
    display: flex;
    flex-direction: column;
    //justify-content: center;
    align-items: flex-start;
  }
  .vid-overlay {
    display:grid;
    .overlay {
      width: 100%;
      height: 100%;
      background-color: transparent;
      grid-area: 1/1;
      z-index: 10;
    }
    .video-player {
      border-radius: 0.325rem;
      filter: drop-shadow(0px 0px 80px rgba(0, 0, 0, 0.5));
      grid-area: 1/1;
    }

  }
}
</style>
